// removed by extract-text-webpack-plugin
module.exports = {"frame":"_3j9019JPpAZFeCKfQ4bAu1","frame_0":"_3ymzSXlo9-u31-a0qqMiim","frame_1":"_11M2gfvdiwdD8ntvT-ZqEz","frame_2":"TGutA6s5zRXl9PsywL2bs","frame_3":"_3nFjB9d3wYp0OF73NdoX6O","frame_large":"tII7g2E_PllQMmJH9EoID"};


//////////////////
// WEBPACK FOOTER
// ../components/Frame/style.module.less
// module id = 419
// module chunks = 0